import CaptivePortalGuest from './CaptivePortalGuest';

export default CaptivePortalGuest;
